import { APIGetRequest } from "@punchup/utils/requests";
import { Comedian } from "@punchup/data/legacy";
import { VideoUploadLogRow } from "@punchup/logging/server";
import { getApiClient } from "@punchup/utils/apiRegistry";

export type VideoUploadSession = {
  sessionStartLog: VideoUploadLogRow;
  allSessionLogs: VideoUploadLogRow[];
};

export interface VideoUploadsApiResponse {
  sessions: VideoUploadSession[];
  comedianMap: Record<string, Comedian>;
  metadata: {
    hasMore: boolean;
    limit: number;
    offset: number;
  };
}

export interface FetchVideoUploadsParams {
  limit?: number;
  offset?: number;
}

export async function fetchVideoUploads(
  params: FetchVideoUploadsParams = {}
): Promise<VideoUploadsApiResponse> {
  const searchParams = new URLSearchParams();

  if (params.limit !== undefined)
    searchParams.set("limit", params.limit.toString());
  if (params.offset !== undefined)
    searchParams.set("offset", params.offset.toString());

  const queryString = searchParams.toString();
  const url = `/api/v2/internal/video-uploads${queryString ? `?${queryString}` : ""}`;

  const response = await getApiClient().get<{
    data: {
      sessions: VideoUploadSession[];
      comedianMap: Record<string, Comedian>;
    };
    metadata: {
      hasMore: boolean;
      limit: number;
      offset: number;
    };
  }>(url);

  return {
    sessions: response.data.sessions,
    comedianMap: response.data.comedianMap,
    metadata: response.metadata,
  };
}
